import { render, staticRenderFns } from "./test_main.vue?vue&type=template&id=59ec7e47&scoped=true"
import script from "./test_main.vue?vue&type=script&lang=js"
export * from "./test_main.vue?vue&type=script&lang=js"
import style0 from "./test_main.vue?vue&type=style&index=0&id=59ec7e47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec7e47",
  null
  
)

export default component.exports